import { render, staticRenderFns } from "./ListeAteliersAnimateur.vue?vue&type=template&id=5855ed88"
import script from "./ListeAteliersAnimateur.vue?vue&type=script&lang=js"
export * from "./ListeAteliersAnimateur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports